import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  appLoading: false,
  viewFilter: {},
  backLinkDiplayed: false,
  currentView: null,
  previousView: null
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateAppLoading: (state, action) => {
      state.appLoading = action.payload;
    },
    updateViewFilter: (state, action) => {
      const { viewName, filterValue } = action.payload;
      state.viewFilter[viewName] = filterValue;
    },
    updateBackLinkDisplayed: (state, action) => {
      state.backLinkDiplayed = action.payload;
    },
    setCurrentView(state, action) {
      const newView = action.payload;
      if (state.currentView !== newView) {
        state.previousView = state.currentView;
        state.currentView = newView;
      }
    },
    resetViews(state) {
      state.currentView = null;
      state.previousView = null;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  updateAppLoading,
  updateViewFilter,
  updateBackLinkDisplayed,
  setCurrentView,
  resetViews
} = appSlice.actions;

export default appSlice.reducer;
